import { useFormik } from 'formik';
import React, { useState, useEffect, ForwardRefRenderFunction, forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { Input } from 'sr/helpers';
import { getUserDetails } from 'sr/helpers/functions/getUserDetails';
import { changePassword } from 'sr/utils/api/changePassword';
import { getCorporate } from 'sr/utils/api/corporate/getCorporate';
import * as Yup from 'yup';

export interface CleanerComponentProps {
  HandleData: (arg: any) => void | null;
  HandleModel: (arg: any) => void | null;
}

const PasswordChange: ForwardRefRenderFunction<any, CleanerComponentProps> = (
  { HandleData, HandleModel },
  ref
) => {
  const intl = useIntl();
  const [password, setPassword] = useState<string>();
  const [currentPassword, setCurrentPassword] = useState<string>();
  const [userId, setUserId] = useState<string>();
  const [corporateId, setCorporateId] = useState<string>();

  useEffect(() => {
    const getdetails = getUserDetails();
    setCorporateId(getdetails.user_id);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (corporateId) {
          const result = await getCorporate(corporateId);
          if (result) {
            setUserId(result?.data?.user_id);
          }
        }
      } catch (error) {
        console.error("Failed to fetch corporate", error);
      }
    };
    if (corporateId) {
      fetchData();
    }
  }, [corporateId]);

  const PasswordChangeSchema = Yup.object({
    password: Yup.string().required('INPUT.VALIDATION.PASSWORD').min(8, 'INPUT.VALIDATION.PASSWORD.MIN.CHARACTER').matches(/(?=.*[0-9!@#$%^&*])/, 'INPUT.VALIDATION.PASSWORD.REQUIREMENTS'),
    old_password: Yup.string()
      .required('INPUT.VALIDATION.PASSWORD')
      .min(8, 'INPUT.VALIDATION.PASSWORD.MIN.CHARACTER'),
  });

  const initialValue = {
    user_id: userId,
    password: password,
    old_password: currentPassword,
  };

  const { errors, submitForm } = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    validationSchema: PasswordChangeSchema,
    onSubmit: async (value) => {
      const res = await changePassword(value);
      if (res?.success === true) {
        HandleModel(false);
      }
    },
  });

  React.useImperativeHandle(ref, () => ({
    submitForm,
  }));

  return (
    <>
      <Input
        error={errors?.password}
        onChange={(e) => {
          setPassword(e.target.value);
        }}
        type="password"
        InputDivClass="mt-0"
        inputClass="border border-zinc-800 rounded-lg h-11"
        label={intl.formatMessage({
          id: 'CORPORATE.ACCOUNT.SETTINGS.INPUT.NEWPASS',
          defaultMessage: 'New password',
        })}
      />

      <Input
        error={errors?.old_password}
        onChange={(e) => {
          setCurrentPassword(e.target.value);
        }}
        type="password"
        InputDivClass="mt-5"
        inputClass="border border-zinc-800 rounded-lg h-11"
        label={intl.formatMessage({
          id: 'CORPORATE.ACCOUNT.SETTINGS.INPUT.CURRENTPASS',
          defaultMessage: 'Current password',
        })}
      />
    </>
  );
};

export default forwardRef(PasswordChange);
